import React from 'react';

const Tag = ({tagName, count}) => {
	return (
		<div className="tag-container">
			<div className="flex justify-between text-sm mb-2">
				<h6 className="font-bold text-sm">{'#' + (tagName)}</h6>
				<p className="text-gray-600">used <b>{count}</b> times</p>
			</div>
		</div>
	)
}

export default Tag
